module.exports = __webpack_public_path__ + "static/media/HelveticaNeueCyr-Medium.fc86185d.woff2";